var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvitationList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.386,
    height: 14.554,
    viewBox: "0 0 17.386 14.554",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "invitation_1_",
    "data-name": "invitation (1)",
    transform: "translate(0 -41.7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3822",
    "data-name": "Path 3822",
    d: "M17.221,46.795h0L15.407,45.7V42.04a.34.34,0,0,0-.34-.34H2.319a.34.34,0,0,0-.34.34v3.654L.163,46.8h0a.339.339,0,0,0-.164.29v8.829a.34.34,0,0,0,.34.34H7.267a.34.34,0,1,0,0-.679H1.553l7.1-4.31,7.17,4.31h-5.7a.34.34,0,0,0,0,.679h6.927a.34.34,0,0,0,.34-.34V47.086a.339.339,0,0,0-.165-.291Zm-1.979,1.771,1.465-.88v7.628L10.362,51.5Zm1.145-1.481-.98.589V46.5ZM2.142,48.577,6.957,51.5.679,55.311V47.689l.455.276,1.008.612Zm-.163-.894-.492-.3-.493-.3.985-.6Zm6.5,2.895-.864.525L2.658,48.1V42.379h12.07v5.7L9.7,51.1l-.876-.526A.34.34,0,0,0,8.476,50.578Z",
    fill: "#adb4b9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    cx: 0.34,
    cy: 0.34,
    r: 0.34,
    transform: "translate(8.353 55.575)",
    fill: "#adb4b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3823",
    "data-name": "Path 3823",
    d: "M166.239,234.039a.34.34,0,0,0-.34-.34h-5.773a.34.34,0,1,0,0,.679H165.9A.34.34,0,0,0,166.239,234.039Z",
    transform: "translate(-154.361 -185.479)",
    fill: "#adb4b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3824",
    "data-name": "Path 3824",
    d: "M128.955,172.373a.34.34,0,0,0-.34-.34h-8.489a.34.34,0,1,0,0,.679h8.489A.34.34,0,0,0,128.955,172.373Z",
    transform: "translate(-115.719 -125.907)",
    fill: "#adb4b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3825",
    "data-name": "Path 3825",
    d: "M160.127,111.045H165.9a.34.34,0,0,0,0-.679h-5.773a.34.34,0,0,0,0,.679Z",
    transform: "translate(-154.361 -66.334)",
    fill: "#adb4b9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitationList);
export default __webpack_public_path__ + "static/media/invitation-list.5522f8e3.svg";
export { ForwardRef as ReactComponent };